import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { toExcelFormat } from 'src/app/helpers/format-position';

@Component({
  selector: 'app-pigeonhole-positions-list',
  templateUrl: './pigeonhole-positions-list.component.html',
  styleUrls: ['./pigeonhole-positions-list.component.scss']
})
export class PigeonholePositionsListComponent implements OnInit {

  @Input() positions = [];
  @Output() onGroupClick = new EventEmitter();
  @Output() onRemove = new EventEmitter();
  @Output() save = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void { }

  getCoordinates(x, y) {
    return toExcelFormat(x, y);
  }

  removePosition(item) {
    this.onRemove.emit(item);
  }

  emitSave() {
    this.save.emit();
  }

  emitCancel() {
    this.cancel.emit();
  }

}
